
(function(){
  // Scroll animations
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('visible'); obs.unobserve(e.target); }
    });
  }, {threshold: 0.15});
  document.querySelectorAll('.trq-fade-up').forEach(function(el){ obs.observe(el); });

  // Back to top
  var btn = document.getElementById('trq-back-top');
  if(btn){
    window.addEventListener('scroll', function(){
      btn.classList.toggle('show', window.scrollY > 400);
    });
    btn.addEventListener('click', function(){ window.scrollTo({top:0,behavior:'smooth'}); });
  }
})();
